"use client";

import FullLoading from "@/components/modal-loading/component-loading";
import FlashMessage from "@/components/snackbar/snackbar";
import { store } from "@/services/store";
import { Toaster } from "@/shadcn/components/ui/sonner";
import "@/styles/globals.scss";
import NextTopLoader from "nextjs-toploader";
import { Provider } from "react-redux";

export default function RootLayout({
	children,
}: Readonly<{
	children: React.ReactNode;
}>) {
	return (
		<html lang="fa" dir="rtl">
			<body className={`antialiased`}>
				<Provider store={store}>
					<NextTopLoader showSpinner={false} />
					{children}
					<Toaster position="top-left" />
					<FullLoading />
					<FlashMessage />
				</Provider>
			</body>
		</html>
	);
}
